import React from "react";

export const IconSidebarDashboard = ({
  width = 24,
  height = 24,
  color = "#F0F0FF",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6508 4.87478C12.2763 4.55379 11.7237 4.55379 11.3492 4.87478L6.34921 9.16049C6.12756 9.35047 6 9.62782 6 9.91975V18.9999C6 19.5522 6.44772 19.9999 7 19.9999H17C17.5523 19.9999 18 19.5522 18 18.9999V9.91975C18 9.62782 17.8724 9.35047 17.6508 9.16049L12.6508 4.87478ZM10.0476 3.35627C11.1711 2.39329 12.8289 2.39329 13.9524 3.35627L18.9524 7.64198C19.6173 8.21193 20 9.04397 20 9.91975V18.9999C20 20.6568 18.6569 21.9999 17 21.9999H7C5.34315 21.9999 4 20.6568 4 18.9999V9.91975C4 9.04397 4.38269 8.21193 5.04763 7.64198L10.0476 3.35627Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6442 4.84983C12.272 4.53638 11.7282 4.53638 11.356 4.84983L3.14423 11.765L1.85596 10.2352L10.0677 3.32001C11.1844 2.37966 12.8158 2.37966 13.9325 3.32001L22.1442 10.2352L20.856 11.765L12.6442 4.84983Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5 14C10.9477 14 10.5 14.4477 10.5 15V19H8.5V15C8.5 13.3431 9.84315 12 11.5 12H12.5C14.1569 12 15.5 13.3431 15.5 15V19H13.5V15C13.5 14.4477 13.0523 14 12.5 14H11.5Z"
        fill={color}
      />
    </svg>
  );
};
